
/* User defined models */
import { Eligibility } from "../scheduling/eligibility.model";
import { Exam } from "../scheduling/exam.model"
import { Candidate } from "../scheduling/candidate.model"

export class LpiData {
    programCode?: string;
    eligibility?: Eligibility;
    exam?: Exam;
    skipPrivacyPage?: boolean;
    terminationUrl?: string;
    pathLock?: boolean;
    candidate?: Candidate;
}